import { createContext } from 'react';
import type { StoreApi } from 'zustand';
import type { WorkspaceInfoStore } from './interfaces';

type Store = StoreApi<WorkspaceInfoStore>;

export const WorkspaceInfoContext = createContext<Store | null>(null);
